

























































































import Vue from 'vue';
import {
  authModule,
  forumRepliesModule,
  forumRepliesState,
  userModule
} from '@/utils/store-acessor';
import { ReplyModel } from '@/models/reply.model';
import { UserModel } from '@/models/user.model';
import { Prop } from 'vue-property-decorator';
import { TopicModel } from '@/models/topic.model';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import ChallengeTopicMessageForm from './ChallengeTopicMessageForm.vue';
import ConfirmDialog from '@/components/Shared/ConfirmDialog.vue';

@Component({
  components: {
    ChallengeTopicMessageForm,
    ConfirmDialog
  }
})
export default class ChallengeTopicMessage extends Vue {
  @Prop({ required: true }) reply!: ReplyModel;
  @Prop({ required: true }) topic!: TopicModel;
  @Prop({ required: true }) challengerId!: number;
  @userModule.Getter('timezone') timezone!: string;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @userModule.Getter('user') currentUser!: UserModel;
  @forumRepliesModule.Getter('isAuthor') isAuthor!: (
    reply: ReplyModel,
    user: UserModel
  ) => boolean;
  showEditForm = false;
  showConfirmDialog = false;

  get author() {
    return this.reply.contestant?.user;
  }

  get location() {
    return this.reply.contestant?.location;
  }

  formatFullName(model: UserModel): string {
    return `${model?.first_name} ${model?.last_name}`;
  }

  formatTimestamp(date: string) {
    return moment(date).tz(this.timezone).format('YYYY/MM/DD, at h:mm');
  }

  isEdited(reply: ReplyModel): boolean {
    return reply.created_at !== reply.updated_at;
  }

  onRemoveReply() {
    if (this.reply.id && this.topic.id) {
      forumRepliesState.destroyReply({
        replyId: this.reply.id,
        topicId: this.topic.id,
        challengeId: this.challengerId
      });
    }
  }

  openPublicProfile() {
    const blankPage = this.$router.resolve(
      `/profile/${this.reply?.contestant?.user?.id}`
    );
    window.open(blankPage.href, '_blank');
  }
}
